import { ThemeOverride } from '@abstractTypes/theme'
import { fonts } from '@theme/index'

export const shTheme: ThemeOverride = {
  colors: {
    primaryDark: '#323131',
    primaryDarkPressed: '#999898',
    primaryLight: '#FFFFFF',
    primaryLightPressed: '#F7F7F7',
    inactive: '#9B9999',
    outline: '#C0C0C0',
    background: '#F7F7F7',
    highlight01: '#323131',
    highlight01Pressed: '#999898',
    highlight02: '#C8AA87',
    highlight02Pressed: '#E5D5BD',
    highlight03: '#323131',
    highlight04: '#504BD6',
    functional01: '#E33F3F',
    functional02: '#A8D277',
    functional03: '#FEBF51',
  },

  fonts: {
    ...fonts,
    heading0: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 100,
        tablet: 75,
        tabletMini: 57,
      },
      lineHeight: {
        tower: 115,
        tablet: 80,
        tabletMini: 72,
      },
    },
    heading1: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 60,
        tablet: 56,
        tabletMini: 48,
      },
      lineHeight: {
        tower: 75,
        tablet: 62,
        tabletMini: 60,
      },
    },
    heading2: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 40,
        tablet: 40,
        tabletMini: 34,
      },
      lineHeight: {
        tower: 48,
        tablet: 48,
        tabletMini: 46,
      },
    },
    heading3: {
      fontFamily: 'Garet',
      weight: {
        regular: 850,
      },
      fontSize: {
        tower: 34,
        tablet: 34,
        tabletMini: 26,
      },
      lineHeight: {
        tower: 44,
        tablet: 42,
        tabletMini: 36,
      },
    },
    heading4: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
        bold: 850,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 30,
        tabletMini: 31,
      },
    },
    heading5: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
        bold: 850,
      },
      fontSize: {
        tower: 20,
        tablet: 20,
        tabletMini: 18,
      },
      lineHeight: {
        tower: 28,
        tablet: 28,
        tabletMini: 28,
      },
    },
    body: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
        bold: 850,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    label: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 14,
        tablet: 14,
        tabletMini: 14,
      },
      lineHeight: {
        tower: 20,
        tablet: 20,
        tabletMini: 20,
      },
    },
    cta: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
        bold: 850,
      },
      fontSize: {
        tower: 18,
        tablet: 16,
        tabletMini: 16,
      },
      lineHeight: {
        tower: 26,
        tablet: 24,
        tabletMini: 24,
      },
    },
    link: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
      },
      fontSize: {
        tower: 24,
        tablet: 24,
        tabletMini: 20,
      },
      lineHeight: {
        tower: 30,
        tablet: 34,
        tabletMini: 31,
      },
    },
    caption: {
      fontFamily: 'Garet',
      weight: {
        regular: 300,
        bold: 850,
      },
      fontSize: {
        tower: 14,
        tablet: 12,
        tabletMini: 12,
      },
      lineHeight: {
        tower: 16,
        tablet: 14,
        tabletMini: 14,
      },
    },
  },
  components: {
    button: {
      style: 'rounded',
      borderRadius: 64,
    },
    rangeSlider: {
      background: '#9B9999', //inactive
      foreground: '#323131', //highlight01
      thumb: '#E8EADF', //background
      thumbBorder: '#9B9999', //inactive
    },
  },
}
